<template>
  <div class="wrapper col-8">
    <div class="animated fadeIn">
      <b-card
        header-tag="header"
        footer-tag="footer">
        <div slot="header">
          <i class="fa fa-edit"></i> MoFA - Air
        </div>
          <!-- BEGIN MOFA FORM -->
            <b-form id="mofa">
              <b-container class="table text-right">
                <b-row>
                  <b-col sm="12">
                    <b-form>
                        <b-row>
                          <b-col sm="6">
                            <b-form-group description="Name of the Agency/Organization">
                              <label for="agency">المنظمة /الدولة</label>                              
                              <b-form-select v-model="agencyId" 
                                   type="text" placeholder="Participant Agency" 
                                   text-field="name" 
                                   value-field="id" 
                                   :options="agencyList" disabled> 
                              </b-form-select>
                              <!-- <b-button class="mt-2" size="sm" variant="primary" v-b-modal.agencyModal v-b-modal.modal-center> <i class="fa fa-plus"></i> أضف وكالة </b-button> -->
                            </b-form-group>
                          </b-col>
                        </b-row>

                        <b-row>
                          <b-col> <hr/> </b-col>
                        </b-row>

                        <b-row>
                          <b-col sm="4">
                            <b-form-group description="Travel Date" class="required">
                              <label for="travelDate">تاريخ الرحلة</label><br>
                              <datepicker format="DD/MM/YYYY" v-model="mofa.travel_date" :local="local" :disabled-date="disabledDate" @input="changeEventHandler"/><br>
                              <small class="text-danger font-weight-bold">{{ validation.firstError('mofa.travel_date') }}</small>
                            </b-form-group>
                          </b-col>
                        </b-row>
                        
                        <b-row>
                          <b-col sm="3">
                              <b-form-group description="Aircraft Signal Call" class="required">
                              <label for="aircraftSignalCall">رقم الرحلة</label><br>
                              <b-form-input type="text" v-model="mofa.aircraft_signal_call" @keyup.native="changeEventHandler"></b-form-input> 
                              <small class="text-danger font-weight-bold">{{ validation.firstError('mofa.aircraft_signal_call') }}</small>
                            </b-form-group>
                          </b-col>
                          <b-col sm="3">
                              <b-form-group description="Registration No" class="required">
                              <label for="registrationNo">رقم التسجيل</label><br>
                              <b-form-input type="text" v-model="mofa.registration_no" @keyup.native="changeEventHandler"></b-form-input> 
                              <small class="text-danger font-weight-bold">{{ validation.firstError('mofa.registration_no') }}</small>
                            </b-form-group>
                          </b-col>
                          <b-col sm="3">
                              <b-form-group description="Landing Permit No." class="required">
                              <label for="landingPermitNo">رقم تصريح الهبوط</label><br>
                              <b-form-input type="text" v-model="mofa.landing_permit_no" @keyup.native="changeEventHandler"></b-form-input> 
                              <small class="text-danger font-weight-bold">{{ validation.firstError('mofa.landing_permit_no') }}</small>
                            </b-form-group>
                          </b-col>                          
                          <b-col sm="3">
                              <b-form-group description="Leasing Company" class="required">
                              <label for="leasingCompany">الشركةالمؤجرة للوسیلة الناقلة </label><br>
                              <b-form-input type="text" v-model="mofa.leasing_company" @keyup.native="changeEventHandler"></b-form-input>
                              <small class="text-danger font-weight-bold">{{ validation.firstError('mofa.leasing_company') }}</small>
                            </b-form-group>
                          </b-col>
                        </b-row>

                        <b-row>
                          <b-col> 
                            <hr/>
                          </b-col>
                        </b-row> 

                        <b-row>
                          <b-col sm="4"> 
                            <b-form-group description="Request Type">
                              <label for="requestTypeId">وسيلة النقل</label>
                              <b-form-select v-model="requestTypeId" 
                                   type="text" placeholder="Request Type" 
                                   text-field="description" 
                                   value-field="id" 
                                   :options="requestTypeList" disabled> 
                              </b-form-select>
                            </b-form-group>
                          </b-col>
                          <b-col sm="4"> 
                            <b-form-group description="Aircraft Type" class="required">
                              <label for="aircraftType">نوع الطائرة</label>
                              <b-form-input type="text" v-model="mofa.aircraft_type" id="aircraftType" @keyup.native="changeEventHandler"></b-form-input> 
                              <small class="text-danger font-weight-bold">{{ validation.firstError('mofa.aircraft_type') }}</small>
                            </b-form-group>                            
                          </b-col>
                        </b-row> 

                        <b-row>
                          <b-col> <hr/> </b-col>
                        </b-row> 

                        <b-row>
                          <b-col sm="6">
                            <b-form-group description="ICAO Route" class="required">
                              <label for="icaoRoute">مسار الرحلة</label>
                              <b-form-textarea id="icaoRoute"
                                v-model="mofa.icao_route"
                                 placeholder="e.g. HDAM-OYSN–HAM"
                                 :rows="5"
                                 :max-rows="8"
                                 @keyup.native="changeEventHandler">
                              </b-form-textarea>
                              <small class="text-danger font-weight-bold">{{ validation.firstError('mofa.flight_route') }}</small>
                            </b-form-group>
                          </b-col>
                          <b-col sm="6">
                            <b-form-group description="Flight Itinerary" class="required">
                              <label for="flightItinerary">مسار الرحلة</label>
                              <b-form-textarea id="flightItinerary"
                                v-model="mofa.flight_itinerary"
                                 placeholder=""
                                 :rows="5"
                                 :max-rows="8"
                                 @keyup.native="changeEventHandler">
                              </b-form-textarea>
                              <small class="text-danger font-weight-bold">{{ validation.firstError('mofa.flight_itinerary') }}</small>
                            </b-form-group>
                          </b-col>
                        </b-row>
                        
                        <b-row>
                          <b-col sm="6"> 
                            <b-form-group description="Cargo Details" class="required">
                              <label for="cargoDetails">تفاصيل الحمولة</label>
                              <b-form-textarea id="cargoDetails"
                                v-model="mofa.cargo_details"
                                 placeholder=""
                                 :rows="3"
                                 :max-rows="6"
                                 @keyup.native="changeEventHandler">
                              </b-form-textarea>
                              <small class="text-danger font-weight-bold">{{ validation.firstError('mofa.cargo_details') }}</small>
                            </b-form-group>
                          </b-col>
                          <b-col sm="6"> 
                            <b-form-group description="Other">
                              <label for="cargoDetails">أي تفاصيل أخرى</label>
                              <b-form-textarea id="other"
                                v-model="mofa.other"
                                 placeholder=""
                                 :rows="3"
                                 :max-rows="6">
                              </b-form-textarea>
                            </b-form-group>
                          </b-col>
                        </b-row>
                    </b-form>
                  </b-col>
                </b-row>
              </b-container>            
          </b-form>
          <!-- END MOFA FORM -->

          <!-- FOOTER -->  
          <div slot="footer" class="float-right">
            <b-button variant="primary" @click="submitEventHandler"><i class="fa fa-save" :disabled="!this.modified"></i>حفظ</b-button>&nbsp;
              <b-button variant="secondary" @click="closeEventHandler"> <i class="fa fa-times"></i> إغلاق</b-button>
          </div>
          <!--// FOOTER -->  
      </b-card>
    </div>

    <!-- UPLOAD -->
    <b-modal hide-footer id="uploadModal" ref="uploadModal" title="Upload Photos">
      <b-form>
        <file-upload
                ref='filename'
                title="Please upload vehicle photos"
                @event-handler="attachEventHandler($event)">            
        </file-upload> 
        <div slot="footer" class="modal-footer">
          <b-button size="md" variant="primary" class="float-right modal-default-button" @click="validationModals('uploadPhotos')">Add</b-button>
          <b-button size="md" variant="secondary" class="float-right modal-default-button" @click="close('upload')">Close</b-button>
        </div>
      </b-form>
    </b-modal>
    <!--// ADD AGENCY -->

    <!--// MODAL Confirm Save -->   
     <b-modal title="Confirm" class="modal-primary" ref="confirmSaveModal" id="confirmSaveModal" @ok="confirmSaveEventHandler" @cancel="close" ok-title="Save" cancel-title="Cancel" centered>
        <p class="my-4">You have unsaved changes on this form.&nbsp;&nbsp;Do you want to Save or Cancel the changes?</p>     
    </b-modal>  
    <!--// MODAL Confirm Save -->  
  
     <!--// MODAL MoFA Save -->   
    <b-modal title="Success" class="modal-primary" ref="confirmMofaModal" id="confirmMofaModal" @ok="submitToDLTEventHandler" @cancel="close" ok-title="Submit" cancel-title="Later" centered>
      <b-row>
        <b-col sm="2" class="text-center"><i class="fa fa-check-circle fa-3x text-success"></i> </b-col>
        <b-col sm="10">
            <p>You've successfully completed MoFA form.  Would you like to submit this notification to OCHA DLT?</p>
        </b-col>
      </b-row>        
    </b-modal>  
    <!--// MODAL MoFA Save -->

  </div>
</template>

<script>
import * as constants from '@/store/constants'
import * as types from '@/store/types'

import NotificationService from '@/api/NotificationService'
import CommonService from '@/api/CommonService'
import MofaService from '@/api/MofaService'

import { mapGetters } from 'vuex'
import { mapState } from 'vuex'

import FileUpload from '@/components/file-upload/FileUpload'
// import { validationMixin } from 'vuelidate'
// import { required, minLength, numeric, alpha, alphaNum } from 'vuelidate/lib/validators'
import * as utils from '@/mixins/utils'
import toast from '@/mixins/toast'
import airMofaMixin from '@/mixins/validators/AirMofa-validators'

export default {  
  components: {
    FileUpload
  },
  data () {
    return {
      local: constants.DATE_LOCALE_EN
    }
  },
  mixins: [
    airMofaMixin    
  ],    
  computed: {
    ...mapGetters({
      agencyList: types.GET_AGENCIES,
      requestTypeList: types.GET_REQUEST_TYPES,
      notificationId: types.GET_NOTIFICATION_ID,
      requestTypeId: types.GET_REQUEST_TYPE_ID,
      agencyId: types.GET_USER_AGENCY_ID,
      mofa: types.GET_MOFA_AIR,
      modified: types.GET_MODIFIED,
      mofaView: types.GET_VIEW_MOFA
    }),
    getAgencyName: function () {
      return (id) => {
        for(var obj of this.agencyList) {
          if(obj.id === id) {
            return obj.name
          }
        }
      }
    }   
  },
  methods: {

    initModal() {
      this.validation.reset()     
    },
    disabledDate (time) {
      var yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      return time < yesterday
    },

    changeEventHandler() {
      this.$store.commit(types.MUTATE_MODIFIED, true)
    },

    showOtherField (e) {
      this.isOtherOrgnization = (e === 1) ? true : false
    },

    confirmSaveEventHandler() {
      this.submitEventHandler()
      setTimeout(function () {
                    this.close()
                }.bind(this), 600)
    },

    submitToDLTEventHandler() {

      let submitted_id = constants.STATUS_SENT_TO_DLT
      let status = this.$_.find(this.$store.state.statusList, {id: submitted_id});
      let notes = this.$moment(new Date()).format('DD/MM/YYYY HH:mm') +'\n'+ status.name

      // enable View MOFA to go to dashboard
      this.$store.commit(types.MUTATE_VIEW_MOFA, true)
      
      const payload = {
            id : this.notificationId,
            status_id : status.id,
            notes : notes,
            ehoc_ref: this.$store.state.ehocRef,
            last_updated_by: this.$store.state.userId
        }
        this.$store.dispatch(types.ACTION_UPDATE_NOTIFICATION_STATUS, payload)

        // modal dialog
        this.$refs.confirmMofaModal.hide()

        const $this = this
        const requestTypeId = this.$store.state.requestTypeId
        let agencyObj = this.$_.find(this.$store.state.agencyList, {id: this.agencyId});
        let requestTypeObj = this.$_.find(this.$store.state.requestTypeList, {id: requestTypeId});
        let messageBody = "Notification Details:\n\n"+
                          "Notification #: "+ this.notificationId +"\n" +
                          "Agency: "+ agencyObj.name +"\n"+
                          "Request type: "+ requestTypeObj.description +"\n"+
                          "Status: "+ status.name

        const notify = {
            to: constants.EMAIL_DLT,
            subject: "Notification #"+ this.notificationId +" has been received",
            message: messageBody
        }
        
        NotificationService.notify(notify).then( (resp) => {
          toast.success("Thank you for your submission. You will receive a confirmation email shortly.")  
        })

        setTimeout(function () {            
            //this.$store.dispatch(types.ACTION_AGENCY_NOTIFICATION_LIST, this.$store.state.agencyId)            
            this.close()
        }.bind(this), 600)

    },
    
    submitEventHandler () {

      const $this = this     
      this.$validate()
          .then(function(success) {

            if (success) {
                let payload = {
                      id: $this.$store.state.mofa.air.id,
                      notification_id: $this.notificationId,
                      agency_id: $this.agencyId,
                      request_type_id: $this.requestTypeId,
                      travel_date: $this.$store.state.mofa.air.travel_date,
                      aircraft_signal_call: $this.$store.state.mofa.air.aircraft_signal_call,
                      registration_no: $this.$store.state.mofa.air.registration_no,
                      landing_permit_no: $this.$store.state.mofa.air.landing_permit_no,
                      leasing_company: $this.$store.state.mofa.air.leasing_company,
                      aircraft_type: $this.$store.state.mofa.air.aircraft_type,
                      icao_route: $this.$store.state.mofa.air.icao_route,
                      flight_itinerary: $this.$store.state.mofa.air.flight_itinerary,
                      cargo_details: $this.$store.state.mofa.air.cargo_details,
                      other: $this.$store.state.mofa.air.other
                }

                 if (payload.id == 0) {
                    $this.$store.dispatch(types.ACTION_ADD_MOFA, payload)

                    if ($this.$store.state.new_notification) {
                        $this.$refs.confirmMofaModal.show()
                    }
                }                    
                else {
                    $this.$store.dispatch(types.ACTION_UPDATE_MOFA, payload)

                    // update status
                    $this.changeNotifcationStatus(constants.STATUS_INUSE)
                }                 
            }
      })

    },

    confirmSaveEventHandler() {
      this.submitEventHandler()
      setTimeout(function () {
                    this.close()
                }.bind(this), 300)
    },

    showOtherField (e) {
      this.isOtherOrgnization = (e === 1) ? true : false
    },

   attachEventHandler(files) {
      if (!files.length) return
      let formData = new FormData();  
      Array.from(Array(files.length).keys())
           .map(i => {
              alert(files[i].name)
              formData.append('file', files[i], files[i].name);
          });
    },
   

    closeEventHandler () {
      if (this.modified) {
          this.$refs.confirmSaveModal.show()
      } 
      else {
          this.close()
      }
    },
    close() {

      if (this.mofaView) {
          this.$store.commit(types.MUTATE_RESET_STATE)
          this.$store.commit(types.MUTATE_VIEW_MOFA, false)
          if (this.$store.state.permission === constants.ADMIN) {
              this.$router.replace('/dashboard')
          }    
          else {
              this.$router.replace('/user-dashboard')
          }
      }
      else {
          this.$router.replace('/forms/air-movement')      
      }
    }
  },
  created() {
      this.$store.dispatch(types.ACTION_FIND_AGENCIES)
      this.$store.dispatch(types.ACTION_FIND_REQUEST_TYPES)

      if (this.mofa.id === 0) {
          this.mofa.travel_date = this.$store.state.start_date          
      }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,  
.fade-leave-to {
  opacity: 0;
}
/*h5 {
  color: #373767;
}
*/
#mofa {
  direction: rtl;
}
/*#mofa .row {
  border-bottom: #c8ced3 solid 1px;
  padding: 10px;
}
*/
.form-group.required label::after {
   margin-right: 2px;
   content:"*";
   color:red;
}
</style>



// WEBPACK FOOTER //
// src/components/forms/Air-Mofa.vue